module.exports = __webpack_public_path__ + "static/media/SuccessWithdraw.1460dc82.svg";